import { TApisOfSchemas } from '../..';
import type ISchemas from './schemas';

const apis: TApisOfSchemas<ISchemas> = {
  getMobileAppKey: (input) => ({
    url: `http://172.23.171.11:9080/mobileApp/getKey`,
    method: 'POST',
    data: input,
    resolveInterceptor: (response) => response.data,
  }),
};

export default apis;
